import LogOutButton from "@Front/Components/DesignSystem/LogOutButton";
import { Routes } from "@Front/Config/Routes";
import classes from "./classes.module.scss";
import MenuItem from "@Front/Components/DesignSystem/Menu/MenuItem";
import { isCustomer as checkIsCustomer, isThirdParty as checkIsThirdParty } from "le-coffre-resources/dist/MemberTypes";
import { usePublicLegalStaticFromSiteConfig } from "@Front/Services/PublicSiteConfig/usePublicLegalStaticFromSiteConfig";
import { useRolePermissionContext } from "@Front/Stores/RolePermissionsStore";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

type IProps = {
	isOpen: boolean;
	closeModal: () => void;
};

function isCustomerRoleOrType(role: string, userType: string): boolean {
	return checkIsCustomer(role) || checkIsCustomer(userType);
}

function isThirdPartyRoleOrType(permissionContext: { globalRole?: string; userType?: string } | null | undefined): boolean {
	return checkIsThirdParty(permissionContext?.userType) || checkIsThirdParty(permissionContext?.globalRole);
}

function getIsClientOrThirdParty(permissionContext: { globalRole?: string; userType?: string } | null | undefined): boolean {
	const normalizedRole = permissionContext?.globalRole?.toLowerCase() ?? "";
	const normalizedUserType = permissionContext?.userType?.toLowerCase() ?? "";
	return isCustomerRoleOrType(normalizedRole, normalizedUserType) || isThirdPartyRoleOrType(permissionContext);
}

export default function ProfileModal({ isOpen }: IProps): React.JSX.Element | null {
	const permissionContext = useRolePermissionContext();
	const publicLegal = usePublicLegalStaticFromSiteConfig();
	const menuLabels = COMMON_UI_I18N.navigationMenu.common;
	if (!isOpen) return null;

	const normalizedContext = permissionContext
		? { globalRole: permissionContext.globalRole ?? undefined, userType: permissionContext.userType ?? undefined }
		: null;
	const isClientOrThirdParty = getIsClientOrThirdParty(normalizedContext);

	return (
		<div className={classes["root"]} data-testid="header-openable-panel" data-openable="profile">
			{!isClientOrThirdParty && (
				<MenuItem item={{ text: menuLabels.myAccount, link: Routes.pages.MyAccount }} />
			)}
			<MenuItem
				item={{
					text: menuLabels.userGuide,
					link: publicLegal.userGuideEntryPath,
					target: "_blank",
				}}
			/>
			<MenuItem item={{ text: menuLabels.cgu, link: "/CGU_LeCoffre_io.pdf", hasSeparator: true }} />
			<LogOutButton />
		</div>
	);
}
